export const isBrowser = typeof window !== "undefined"

export const event = (name: string, data: any) => {
  if (!isBrowser) return
  if (!(window as any).gtag) return
  ;(window as any).gtag("event", name, data)
}
